import React from "react";

import SourceCellContent from "../components/SourceCellContent";

import base from "./base";

import { Column, ColumnId } from ".";

function source({ width, onResize, language }: Column.Options) {
	return base(
		ColumnId.Source,
		(item) => <SourceCellContent item={item} language={language} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default source;
